<script setup lang="ts">
import { GTMContentGroup } from '~/lib/models/gtm'

const restaurantStore = useRestaurantStore()
const { trackPageView } = useGTM()

const MIN_PAGE = 1
const MAX_PAGE = 2
const page = ref(MIN_PAGE)

const previousPage = () => {
  if (page.value > MIN_PAGE) {
    page.value--
    trackAddressPage()
  }
}

const nextPage = () => {
  if (page.value < MAX_PAGE) {
    page.value++
    trackAddressPage()
  }
}

const trackAddressPage = () => {
  trackPageView(
    {
      cg: GTMContentGroup.primary.ECOMMERCE,
      cg2: GTMContentGroup.secondary.LOCATOR,
      cg3:
        page.value === MIN_PAGE
          ? GTMContentGroup.tertiary.ADDRESS_ADD
          : GTMContentGroup.tertiary.ADDRESS_MAP,
    },
    true
  )
}

onMounted(() => {
  trackAddressPage()
})
</script>

<template>
  <DLVAddInfo
    v-if="page === 1 && restaurantStore.selectedGoogleLocation"
    :selected-location="restaurantStore.selectedGoogleLocation"
    :next-page="nextPage"
  />
  <DLVSelectRestaurant
    v-if="page === 2 && restaurantStore.selectedGoogleLocation"
    :selected-location="restaurantStore.selectedGoogleLocation"
    :previous-page="previousPage"
  />
</template>
